// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { getType } from 'typesafe-actions';

import { Support, SupportReply } from '../../types/Model';
import { RootAction, actionCreatorsList } from '../rootActionCreator';

export interface createNewSupportPageState {
  data: Support | {};
  isLoading: boolean;
  error?: Error;
}

const {
  createNewSupportActions,
} = actionCreatorsList;

export const initialState: createNewSupportPageState = {
  data: {},
  isLoading: false,
};

const supportListReducer = (state = initialState, action: RootAction): createNewSupportPageState => {
  switch (action.type) {
    case getType(createNewSupportActions.request): {
      return {
        ...state,
        isLoading: true,
        error: undefined
      };
    }
    case getType(createNewSupportActions.success): {
      const { data } = action.payload
      return {
        ...state,
        isLoading: false,
        data
      };
    }
    case getType(createNewSupportActions.failure): {
      return {
        ...state,
        isLoading: false,
        error: action.payload.error
      };
    }
    default: {
      return state;
    }
  }
}

export { supportListReducer as default };
